<template>
  <div id="app">
    <app-header :app-name="appName" />
    <router-view />
    <notifications group="app" />
  </div>
</template>

<script>
import AppHeader from './components/layout/app-header';
import appConfig from './app.config';

export default {
  name: 'App',
  components: {
    AppHeader
  },
  data: function () {
    return {
      appName: appConfig.appName
    };
  },
  computed: {
    appFooterDisplayed() { return this.$route.meta.appFooterDisplayed; }
  }
};
</script>

<style>
  .vue-notification {
    padding: 10px;
    margin: 5px 5px 5px;
    font-size: 15px;
  }
</style>
